import { Injectable } from '@angular/core';
import { AwsUser } from '@app/auth/models';
import {
    confirmSignIn,
    fetchAuthSession,
    getCurrentUser,
    resendSignUpCode,
    ResendSignUpCodeOutput,
    signIn,
    SignInOutput,
    signOut,
} from '@aws-amplify/auth';
import { AuthSession } from '@aws-amplify/core';
import { from, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    cognitoUser?: AwsUser;

    async getUser(): Promise<AwsUser> {
        this.cognitoUser = await getCurrentUser();
        return this.cognitoUser!;
    }

    getCurrentSession(): Promise<AuthSession> {
        return fetchAuthSession();
    }

    logout() {
        return signOut();
    }

    resendVerificationCode(email: string): Promise<ResendSignUpCodeOutput> {
        return resendSignUpCode({ username: email });
    }

    login(email: string, password: string): Promise<SignInOutput> {
        return signIn({ username: email, password });
    }

    isAuthenticated(): Observable<boolean> {
        return from(getCurrentUser()).pipe(
            map(() => true),
            catchError(() => of(false)),
        );
    }

    async completeNewPassword(newPassword: string) {
        await confirmSignIn({ challengeResponse: newPassword });
        return this.getUser();
    }
}
